import React from 'react'
import './About.css'
import Heading from './Heading'

function About() {
  return (
    <div className='about'>
      <Heading title='background' />
      <div className='about__info'>
        <p>
          I'm a self taught full-stack developer. I taught myself coding by
          watching awesome tutorials on youtube (and the good old docs obv 📁)
          and then going on to build my own projects. I believe in the mantra of
          learning and executing by building your own projects (hence avoiding
          tutorial hell 🤯)
        </p>
        <p>
          Aside from a developer and staring at a computer screen all day, I'm a{' '}
          <a
            href='https://www.callofduty.com/ar/en/mobile'
            target='_blank'
            rel='noreferrer'
          >
            CODM
          </a>{' '}
          competitive gamer playing for one of the best EU org{' '}
          <a
            href='https://www.instagram.com/tragik_esports/'
            target='_blank'
            rel='noreferrer'
          >
            Tragik Esports
          </a>
          . Although this might feel irrelevant to you. But believe me, playing
          competitive at this stage takes you to the next level not only in
          gaming but in real life too 😉
        </p>
      </div>
    </div>
  )
}

export default About
